import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Fetches a CMS collection (board | events | spotlights) with its visibility flag. */
export function useCollection(name) {
  const [state, setState] = useState({ items: [], visible: true, loading: true });
  useEffect(() => {
    let alive = true;
    axios
      .get(`${API}/${name}`)
      .then((r) => alive && setState({ items: r.data.items || [], visible: r.data.visible !== false, loading: false }))
      .catch(() => alive && setState({ items: [], visible: false, loading: false }));
    return () => {
      alive = false;
    };
  }, [name]);
  return state;
}
